import PropTypes from 'prop-types';
import React from 'react';
import BookmarkContainer from './Bookmark.styled';
import Colors from 'pubweb-smokey/dist/colors';
import BookmarkGraphic from './BookmarkSVG';
import Tooltip from '../Tooltip/Tooltip';

const Bookmark = ({
  isBookmarked,
  onBookmarkClick,
  bookmarkSVGWidth = '24',
  bookmarkSVGHeight = '30',
  placement = 'left',
}) => {
  return (
    <BookmarkContainer
      className="bookmark-container"
      placement={placement}
      bookmarkSVGHeight={bookmarkSVGHeight}
      bookmarkSVGWidth={bookmarkSVGWidth}
    >
      <Tooltip
        arrowDirection={placement === 'left' ? 'right' : 'down'}
        tooltipText={isBookmarked ? <span>Remove</span> : <span>Bookmark</span>}
        isVisible={false}
      />
      <div onClick={onBookmarkClick}>
        <BookmarkGraphic
          className="bookmark-graphic"
          colorFill={
            isBookmarked ? Colors.secondary.rubberDucky.standard : '#fff'
          }
          stroke={isBookmarked ? 'none' : '#4a4a4a'}
          bookmarkColor={Colors.secondaryRubberDucky}
        />
      </div>
    </BookmarkContainer>
  );
};

Bookmark.propTypes = {
  bookmarkSVGHeight: PropTypes.string,
  bookmarkSVGWidth: PropTypes.string,
  isBookmarked: PropTypes.any,
  onBookmarkClick: PropTypes.any,
  placement: PropTypes.string,
};

export default Bookmark;
